module.exports = __webpack_public_path__ + "static/media/sacramento-bautizos-santuario.0e778bb7.jpg";